// @ts-nocheck
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

/* Store Custom Code - Start */
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
/* Store Custom Code - End */

export const productDetailsFormWrapperStyles = () => {
    return css`
        ${({ theme }) => {
            const spacing = theme.design.product.detail.contentSpacing;
            return spacingStyles(spacing, spacing);
        }}

        padding-bottom: ${pxToRem(4)};

        /* Store Custom Code - Start */
        ${breakpoint("sm")} {
            max-width: ${pxToRem(400)};
        }
        /* Store Custom Code - Start */
    `;
};
